export default {
  title: 'Crear nueva contraseña',
  description: 'Crea una nueva contraseña para tu cuenta.',
  form: {
    new_password: {
      label: 'Nueva contraseña',
      placeholder: 'Introduce la contraseña',
      requirements: 'Tu contraseña debe tener 8 caracteres, una mayúscula y un número',
    },
    confirm_password: {
      label: 'Confirmación de nueva contraseña',
      placeholder: 'Confirmar contraseña',
    },
    error_messages: {
      missing_info: 'Información faltante',
    },
  },
  buttons: {
    update_password: 'Actualizar contraseña',
  },
};
